import React, { createContext, useContext, useState } from "react";

const StateContext = createContext();

export const ContextProvider = ({ children }) => {
  const [component, setComponent] = useState("");
  const [deletedcomp, setDeletedComp] = useState("");
  const [activityid, setActivityId] = useState("");
  const [activitydata, setActivityData] = useState([]);
  const [activityarr, setActivityArr] = useState([]);
  const [performanceid, setPerformanceId] = useState([]);
  const [submitperform, setSubmitPerform] = useState(false);
  const [deletedbookingcomp, setDeletedBookingComp] = useState("");
  const [bookingcomp, setBookingComp] = useState("");
  const [bookingdata, setBookingData] = useState([]);
  const [bookingtemplateid, setBookingTemplateId] = useState("");
  const [bookingid, setBookingId] = useState("");
  const [bookingpropsid, setBookingPropsId] = useState("");
  const [bookingarr, setBookingArr] = useState([]);
  const [params, setParams] = useState("");
  const [dropdownparams, setDropdownParams] = useState("");
  const [activityparams, setActivityParams] = useState("");
  const [activitydropdownparams, setActivityDropdownParams] = useState([]);
  const [retainprops, setRetainProps] = useState(false);
  const [retaindata, setRetainData] = useState(false);
  const [focuscontrolid, setFocusControlId] = useState("");
  const [checkfocus, setCheckFocus] = useState(true);
  const [bookingname, setBookingName] = useState("");
  const [priordate, setPriorDate] = useState(false);
  const [futuredate, setFutureDate] = useState(false);
  const [listvalues, setListValues] = useState([]);
  const [submitbooking, setSubmitBooking] = useState(false);
  const [updatebooking, setUpdateBooking] = useState(false);
  const [activitypriordate, setActivityPriorDate] = useState(false);
  const [activityfuturedate, setActivityFutureDate] = useState(false);
  const [activitylistvalues, setActivityListValues] = useState([]);
  const [submitactivity, setSubmitActivity] = useState(false);
  const [inputlen, setInputLen] = useState(0);
  const [updateactivity, setUpdateActivity] = useState(0);
  const [previewinputs, setPreviewInputs] = useState([]);
  // const [submitcreatebooking, setSubmitCreateBooking] = useState(false);
  const [activitypreviewinputs, setActivityPreviewInputs] = useState([]);
  const [activitydataobj, setActivityDataObj] = useState([]);
  const [allowcontrolupdate, setAllowControlUpdate] = useState(false);
  const [createactivityid, setCreateActivityId] = useState("");
  return (
    <StateContext.Provider
      value={{
        component,
        setComponent,
        deletedcomp,
        setDeletedComp,
        activityid,
        setActivityId,
        activitydata,
        setActivityData,
        activityarr,
        setActivityArr,
        performanceid,
        setPerformanceId,
        submitperform,
        setSubmitPerform,
        deletedbookingcomp,
        setDeletedBookingComp,
        bookingcomp,
        setBookingComp,
        bookingdata,
        setBookingData,
        // bookingtemplateid,
        // setBookingTemplateId,
        bookingpropsid,
        setBookingPropsId,
        bookingarr,
        setBookingArr,
        bookingid,
        setBookingId,
        params,
        setParams,
        dropdownparams,
        setDropdownParams,
        retainprops,
        setRetainProps,
        activityparams,
        setActivityParams,
        activitydropdownparams,
        setActivityDropdownParams,
        retaindata,
        setRetainData,
        focuscontrolid,
        setFocusControlId,
        checkfocus,
        setCheckFocus,
        bookingname,
        setBookingName,
        priordate,
        setPriorDate,
        futuredate,
        setFutureDate,
        listvalues,
        setListValues,
        submitbooking,
        setSubmitBooking,
        updatebooking,
        setUpdateBooking,
        activitypriordate,
        setActivityPriorDate,
        activityfuturedate,
        setActivityFutureDate,
        activitylistvalues,
        setActivityListValues,
        submitactivity,
        setSubmitActivity,
        inputlen,
        setInputLen,
        updateactivity,
        setUpdateActivity,
        // submitcreatebooking,
        // setSubmitCreateBooking,
        previewinputs,
        setPreviewInputs,
        activitypreviewinputs,
        setActivityPreviewInputs,
        activitydataobj,
        setActivityDataObj,
        allowcontrolupdate,
        setAllowControlUpdate,
        createactivityid,
        setCreateActivityId,
      }}
    >
      {children}
    </StateContext.Provider>
  );
};

export default StateContext;
export const useStateContext = () => useContext(StateContext);
